import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Flex } from "sprout-ui-primitives";
import styled from "styled-components";
import { PushPin, Bookmark } from "sprout-ui-icons";
import { ItemFocusWhen } from "sprout-graphql";
const PostMarkersWrapper = styled(Flex)`
  position: absolute;
  top: 0;
  left: -9px;
`;
const StyledPostMarkersWrapper = styled(PostMarkersWrapper)`
  svg {
    width: 18px;
    height: 18px;
  }
`;
const PostMarkers = (props)=>{
    const { focusWhen  } = props;
    const isFocusNow = focusWhen === ItemFocusWhen.Now;
    const isSetAside = focusWhen === ItemFocusWhen.Later;
    return /*#__PURE__*/ _jsxs(StyledPostMarkersWrapper, {
        color: isFocusNow ? "#fccc03" : "#ff9300",
        children: [
            isFocusNow && /*#__PURE__*/ _jsx(PushPin, {}),
            isSetAside && /*#__PURE__*/ _jsx(Bookmark, {})
        ]
    });
};
export default PostMarkers;
